import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = {
  notifications: [],
  templates: {},
  pendingRequests: [],
};

const NotificationSlice = createSlice({
  name: 'Notifications',
  initialState,

  reducers: {
    setNotifications(state, { payload }: PayloadAction<any>) {
      state.notifications = payload;
    },

    setTemplates(state, { payload }: PayloadAction<any>) {
      state.templates = payload;
    },

    setPendingRequests(state, { payload }: PayloadAction<any>) {
      state.pendingRequests = payload;
    },
  },
});

export const { setNotifications, setTemplates, setPendingRequests } = NotificationSlice.actions;

export default NotificationSlice.reducer;
